import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ChevronIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 13 21",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 21),
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    ...svgProps,
    children: /*#__PURE__*/jsx("path", {
      d: "m1.9 19.8 9.2-9.3L2 1.2"
    })
  });
};

export { ChevronIcon };
//# sourceMappingURL=chevron.js.map
